import React from 'react';

const ShopifyTrackEventContext = React.createContext({
  fireShopifyTrackEvent: () => {},
});

export default ShopifyTrackEventContext;
